import { signal } from '@preact/signals';
import { StartScreen } from './components/screens/StartScreen';
import { AuthScreen } from './components/screens/AuthScreen';
import { UniverseSelect } from './components/screens/UniverseSelect';
import { GenreSelect } from './components/screens/GenreSelect';
import { DurationSelect } from './components/screens/DurationSelect';
import { CharacterCreate } from './components/screens/CharacterCreate';
import { GameScreen } from './components/screens/GameScreen';
import { SaveLoadScreen } from './components/screens/SaveLoadScreen';

export type Screen = 'start' | 'auth' | 'saves' | 'universe' | 'genre' | 'duration' | 'character' | 'game';

export const currentScreen = signal<Screen>('start');

export const gameSetup = signal<{
  universeId?: string;
  language?: string;
  genre?: string;
  duration?: string;
}>({});

export const activeGame = signal<{ saveId: string; wsUrl: string } | null>(null);

export function App() {
  return (
    <div class="crt">
      {currentScreen.value === 'start' && <StartScreen />}
      {currentScreen.value === 'auth' && <AuthScreen />}
      {currentScreen.value === 'saves' && <SaveLoadScreen />}
      {currentScreen.value === 'universe' && <UniverseSelect />}
      {currentScreen.value === 'genre' && <GenreSelect />}
      {currentScreen.value === 'duration' && <DurationSelect />}
      {currentScreen.value === 'character' && <CharacterCreate />}
      {currentScreen.value === 'game' && activeGame.value && (
        <GameScreen saveId={activeGame.value.saveId} wsUrl={activeGame.value.wsUrl} />
      )}
    </div>
  );
}
